const styles = () => ({
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "12px",
  },
  checkboxLabel: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#355273",
  },
  formTitle: {
    fontSize: "24px",
    fontWeight: 600,
    color: "#2D2E2E",
  },
  formSubtitle: {
    fontSize: "16px",
    color: "#355273",
    "& > span": {
      fontWeight: 700,
      fontSize: "16px",
    },
  },
  title: {
    marginBottom: "1.5rem",
  },
});

export default styles;
